(function () {

    angular
        .module('app')
        .controller('QitanAiController', QitanAiController);

    QitanAiController.$inject = [
        'authService', 'qitanAiContractService', '$window', 'loggerService', '$timeout'
    ];

    function QitanAiController(authService, qitanAiContractService, $window, loggerService, $timeout) {
        var vm = this;
        var activeLaunchAttempt = null;
        var launchTimeoutMs = 30000;

        vm.requiresLogin = !authService.isAuthenticated();
        vm.launching = false;
        vm.launchError = '';
        vm.openAgentWorkspace = openAgentWorkspace;

        function openAgentWorkspace() {
            if (!authService.isAuthenticated()) {
                return loginForWorkspace();
            }
            if (vm.launching) {
                return;
            }

            vm.launching = true;
            vm.launchError = '';

            var launchAttempt = {};
            activeLaunchAttempt = launchAttempt;
            var launchTimeout = $timeout(function () {
                if (activeLaunchAttempt !== launchAttempt || !vm.launching) {
                    return;
                }
                activeLaunchAttempt = null;
                vm.launching = false;
                vm.launchError = '进入智能体工作台超时，请重试';
            }, launchTimeoutMs);

            return authService.requirePlatformSessionCookie()
                .then(function () {
                    if (activeLaunchAttempt !== launchAttempt) {
                        return null;
                    }
                    return qitanAiContractService.getStudioLaunch('/space');
                })
                .then(function (launch) {
                    var parsedUrl;
                    if (activeLaunchAttempt !== launchAttempt) {
                        return;
                    }
                    if (!launch || typeof launch.url !== 'string' || !launch.url) {
                        throw new Error('智能体工作台入口没有返回可用地址');
                    }
                    try {
                        parsedUrl = new $window.URL(launch.url, $window.location.origin);
                    }
                    catch (err) {
                        throw new Error('智能体工作台返回了不受信任的地址');
                    }
                    if (parsedUrl.origin !== $window.location.origin ||
                        !isAllowedLaunchPath(parsedUrl.pathname)) {
                        throw new Error('智能体工作台返回了不受信任的地址');
                    }
                    vm.launching = false;
                    $window.location.replace(parsedUrl.href);
                })
                .catch(function (err) {
                    if (activeLaunchAttempt !== launchAttempt) {
                        return;
                    }
                    loggerService.error(err);
                    vm.launching = false;
                    if (err && err.requiresLogin) {
                        return loginForWorkspace();
                    }
                    showLaunchError(err);
                })
                .finally(function () {
                    if (activeLaunchAttempt === launchAttempt) {
                        activeLaunchAttempt = null;
                        $timeout.cancel(launchTimeout);
                    }
                });
        }

        function loginForWorkspace() {
            var loginResult;
            try {
                loginResult = authService.login('qitan_agent_workspace', {});
            }
            catch (err) {
                loggerService.error(err);
                showLaunchError(err);
                return;
            }
            if (loginResult && typeof loginResult.catch === 'function') {
                return loginResult.catch(function (err) {
                    loggerService.error(err);
                    showLaunchError(err);
                });
            }
            return loginResult;
        }

        function showLaunchError(err) {
            vm.launchError = (err && err.data && (err.data.error || err.data.next)) ||
                (err && err.message) ||
                '智能体工作台暂时无法进入';
        }

        function isAllowedLaunchPath(pathname) {
            return pathname === '/qitan-workbench/agent' ||
                pathname.indexOf('/qitan-workbench/agent/') === 0;
        }
    }
}());
